// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

// Internal Dependencies
import MText from './Common/MText';
import { IsEmpty } from '../common/checks';

function MonthDayValidity(props) {
  const onValueChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseInt(value, 10);

    if (name === 'validityInMonths') {
      props.setValidityInMonths(parsedValue);
    } else {
      props.setValidityInDays(parsedValue);
    }
  };

  return (
    <div className="d-flex flex-column">
      {!IsEmpty(props.description) && (
        <MText className="mt-0" size={props.textSize} text={props.description} />
      )}
      <div className="d-flex mt-2">
        <TextField
          value={props.validityInMonths || ''}
          name="validityInMonths"
          onChange={onValueChange}
          variant="outlined"
          size="small"
          type="number"
          className="mr-4"
          label="months"
          disabled={props.disabled}
          inputProps={{
            min:   1,
            style: {
              fontSize: props.textSize,
              width:    '6.75rem',
            },
          }}
        />
        <TextField
          value={props.validityInDays || ''}
          name="validityInDays"
          onChange={onValueChange}
          variant="outlined"
          size="small"
          type="number"
          label="days"
          disabled={props.disabled}
          inputProps={{
            min:   1,
            style: {
              fontSize: props.textSize,
              width:    '6.75rem',
            },
          }}
        />
      </div>
    </div>
  );
}

MonthDayValidity.defaultProps = {
  disabled:    false,
  textSize:    12,
  description: '',
};

MonthDayValidity.propTypes = {
  description:      PropTypes.string,
  validityInMonths: PropTypes.number.isRequired,
  validityInDays:   PropTypes.number.isRequired,

  setValidityInMonths: PropTypes.func.isRequired,
  setValidityInDays:   PropTypes.func.isRequired,

  textSize: PropTypes.number,
  disabled: PropTypes.bool,
};

export default MonthDayValidity;
